/**
 * Whether the 236px sidebar column is expanded — the rail's own
 * collapse/expand chevron (`AppShell`'s `navOpen`). `localStorage`, not
 * `sessionStorage`: this should survive a reload and a new tab, not die
 * with either.
 */

const KEY = 'bp.files.sidebarOpen';

/**
 * Best-effort by design: storage can throw when it is disabled or full, and
 * a reader who cannot have a remembered preference must still see a working
 * shell. Every failure reads as "nothing chosen yet" — the caller falls back
 * to its own default.
 */
export function readSidebarOpen(): boolean | null {
  try {
    const value = window.localStorage.getItem(KEY);
    return value === null ? null : value === 'true';
  } catch {
    return null;
  }
}

export function writeSidebarOpen(open: boolean): void {
  try {
    window.localStorage.setItem(KEY, String(open));
  } catch {
    /* a preference we cannot remember is not worth failing over */
  }
}
